import { render, staticRenderFns } from "./minimal.vue?vue&type=template&id=6d73b8a8&scoped=true"
import script from "./minimal.vue?vue&type=script&lang=js"
export * from "./minimal.vue?vue&type=script&lang=js"
import style0 from "./minimal.vue?vue&type=style&index=0&id=6d73b8a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d73b8a8",
  null
  
)

export default component.exports